import React, { Component } from 'react';
import styled from 'styled-components';
import QRCode from 'qrcode-react';
import {
    PrestoAppComponents,
    PrestoAppTheme,
} from 'presto-mini-apps-lib';
import connectPage from '../../scenes/Main/index';
import PageWrapper from '../../components/PageWrapper';
import Tabber from '../../components/Tabber';
import PaymentDetails from '../../components/PaymentDetails';

import Routes from '../../constants/routes';
import {
    PayOptionTabList, 
    isMobile,
} from '../../constants/appState';
import { 
    term_AppStore,
    term_GooglePlay, 
    term_AppGallery,
    phrase_QRScanInstruction, 
    phrase_QRScanSteps 
} from '../../constants/text';
import { QRCodePrestoLogo, AppGalleryLogo } from '../../assets/images';
import {appService, serviceConstants} from '../../services';

class QRScan extends Component {
    pageName;

    constructor(props) {
        super(props);
        this.pageName = Routes.QRSCANPAY;
        this.state = {
            finishLoad: false
        }
    }

    componentDidMount() {
        const { mainProps } = this.props;
        // Do not show the page if it is trying to register as guest
        if(!mainProps.transactionState.allowGuestPayment || !mainProps.appState.isSkipLogin) {
            this.setState({
                finishLoad: true
            });
        }
    }

    render() {
        const {
            mainProps,
            actionHandler
        } = this.props;
        const { finishLoad } = this.state;

        const QRCleanStr = (mainProps.transactionState.qrValue).replace(/&amp;/g, '&');

        return (
            <PageWrapper showRedirectLink>
                <QRScanWrapper className="page-qr-scan">
                    { finishLoad && (
                        <>
                            { !isMobile() ? (
                                <Tabber
                                    currentActiveTab={PayOptionTabList[0].id}
                                    tabList={PayOptionTabList}
                                    clickHandler={actionHandler.changePageHandler}
                                />
                            ) : null}

                            <PaymentDetails
                                payAmount={mainProps.transactionState.paymentAmount}
                                paymentDetails={mainProps.transactionState.paymentDescription}
                                itemList={mainProps.transactionState.paymentItemList}
                                appState={mainProps.appState}
                            />

                            <div className="qrcode-wrapper">
                                <div className="qrcode">
                                    <QRCode
                                        value={QRCleanStr || 'PrestoPay'}
                                        size={qrCodeSize}
                                        logo={QRCodePrestoLogo}
                                        logoWidth={qrCodeSize * .25}
                                    />
                                </div>
                                <PrestoAppComponents.HorizontalLine />
                            </div>

                            <div className="qr-instruction">
                                <div className="instructions">
                                    <span>{phrase_QRScanInstruction}</span>
                                    <ol>
                                        { phrase_QRScanSteps.map((item, key) => <li key={key}>{item}</li>)}
                                    </ol>
                                </div>
                                <div className="buttons">
                                    <a href={serviceConstants.PathConst.GOOGLE_PLAY_LINK} target="_blank" rel="noopener noreferrer" className="link-google-play">{term_GooglePlay}</a>
                                    <a href={serviceConstants.PathConst.APP_STORE_LINK} target="_blank" rel="noopener noreferrer" className="link-app-store">{term_AppStore}</a>
                                    <a href={serviceConstants.PathConst.APP_GALLERY_LINK} target="_blank" rel="noopener noreferrer" className="link-app-gallery">{term_AppGallery}</a>
                                </div>
                            </div>
                        </>
                    )}
                </QRScanWrapper>
            </PageWrapper>
        );
    }
}

export default connectPage(QRScan);

const qrCodeSize = 195;
const QRScanWrapper = styled.div`
    & .qrcode-wrapper {
        padding: 0 ${PrestoAppTheme.layout.smallGap};
        
        & .qrcode {
            position: relative;
            width: ${qrCodeSize}px;
            height: ${qrCodeSize}px;
            margin: 0 auto;
            
            & > img {
                ${PrestoAppTheme.layout.absoluteFullStyle}
                background-color: ${PrestoAppTheme.colors.baseBlack};
            }
        }
    }

    & .qr-instruction {
        display: flex;
        padding: 0 ${PrestoAppTheme.layout.smallGap} ${PrestoAppTheme.layout.smallGap};
        justify-content: space-between;

        & .instructions {
            width: calc(100% - 120px);

            & > span { 
                font-weight: 400;
            }

            & > ol {
                padding: 0 0 0 ${PrestoAppTheme.layout.commonGap};
                margin: 0;

                & > li {
                    margin: ${PrestoAppTheme.layout.smallGap} 0;
                }
            }
        }

        & .buttons {
            width: 120px;

            & > a {
                display: inline-block;
                height: 0;
                width: 100%;
                margin-bottom: ${PrestoAppTheme.layout.xSmallGap};
                background: center / contain no-repeat;
                vertical-align: top;
                font-size: 0;
                cursor: pointer;
            }
            
            & .link-app-store {
                padding-bottom: 33.775%;
                background-image: url(${PrestoAppTheme.images.AppStoreBanner.src});
            }
            
            & .link-google-play { 
                padding-bottom: 29.532%;
                background-image: url(${PrestoAppTheme.images.GooglePlayBanner.src});
            }

            & .link-app-gallery { 
                padding-bottom: 29.532%;
                background-image: url(${PrestoAppTheme.images.AppGalleryBanner.src});
            }
        }
    }    
`;